import { Select, Space } from 'antd';
import styles from './index.module.scss';
import { paymentOptions } from 'utils/utils';

type Props = {
	dateValue: any;
	handleDatePicker: any;
	filterOptions: string;
	handleStatusFilter: (value: string) => void;
	handleBankType: (value: string) => void;
	bankType: string;
};

const PaymentTableHeader = (props: Props) => {
	const {
		filterOptions,
		handleStatusFilter,
		handleBankType,
		bankType,
		// button,
	} = props;

	return (
		<div className={styles['employee-header']}>
			<Space>
				<Select
					className={styles['employee-header-item']}
					value={filterOptions}
					style={{
						width: '200px',
					}}
					options={paymentOptions}
					onChange={(value) => {
						handleStatusFilter(value);
					}}
					size="large"
					placeholder="Select by supervisor"
				/>
				<Select
					className={styles['employee-header-item']}
					value={bankType}
					style={{
						width: '200px',
					}}
					options={[
						{
							label: 'First Capital Bank',
							value: 'FCB',
						},
						{
							label: 'Stanbic Bank',
							value: 'STANBIC',
						},
					]}
					onChange={(value) => {
						handleBankType(value);
					}}
					size="large"
					placeholder="Select by supervisor"
				/>
			</Space>
		</div>
	);
};

export default PaymentTableHeader;
